import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ModalGeneric } from '../../../../../ui/generics';
import { VouchersService } from '../../../core/services/VouchersService';
import { finalize } from 'rxjs/operators';
import { IVoucherHistoryItem } from '../../../core/interfaces/IVoucherHistoryItem';
import { VoucherCodeStatuses } from '../../../core/enums/VoucherCodeStatuses';
import { VoucherHistoryOperations } from '../../../core/enums/VoucherHistoryOperations';

@Component({
    selector: 'app-voucher-history-modal',
    templateUrl: './voucher-history-modal.component.html',
    styleUrls: ['./voucher-history-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VoucherHistoryModalComponent extends ModalGeneric implements OnInit {

  public history: IVoucherHistoryItem[] = [];
  public title = 'Verlauf der Gutscheine';
  public isLoading = false;
  public isPercentage: boolean;
  public readonly voucherCodeStatuses = VoucherCodeStatuses;
  public readonly voucherHistoryOperations = VoucherHistoryOperations;

  private _id: number;

  constructor(
    protected readonly cdr: ChangeDetectorRef,
    private readonly _vouchersService: VouchersService
  ) {
    super(cdr);
  }

  public ngOnInit(): void {}

  public showModal(object: { id: number; isPercentage: boolean; }) {
    super.showModal(object);

    this.isPercentage = object.isPercentage;
    this._id = object.id;

    this.loadHistory();
  }

  private loadHistory(): void {
    this.isLoading = true;

    this._vouchersService.getVoucherHistory(this._id).pipe(
      finalize(this.stopIsLoading.bind(this))
    ).subscribe(history => this.history = history);
  }

  private stopIsLoading(): void {
    this.isLoading = false;
    this.cdr.detectChanges();
  }
}
